import { render, staticRenderFns } from "./ContentPanel.vue?vue&type=template&id=0afb7146&"
import script from "./ContentPanel.vue?vue&type=script&lang=js&"
export * from "./ContentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports